import * as React from 'react';
import { Link } from "react-router-dom";
import { useQuery } from '../../Components/Query';
import { Column, Table } from "../../Components/QueryTable";
import { useCurrentStudyConfigurationContext } from '../../Core/CurrentStudyConfigurationContext';
import { Authorization } from "../../misc/components/Authorization";
import { useSecurityContext } from "../../Core/SecurityContext";
import { PermissionEnum } from "../../misc/api/ApiPermissionEnum";
import { formatDateTime } from '../../misc/components/Formatters/Formatters';
import { MatchSortHeader } from '../../Components/MatchSortHeader';
import { useState } from 'react';
import { useEffect } from 'react';
import { WebPortalClient } from 'webportalclient/obj/Swagger/WebPortalClient';
import { SortHeader } from '../../Components/SortHeader';
import { useWebPortalApiClient } from '../../misc/api/WebPortalTokenClient';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from '@fortawesome/free-solid-svg-icons';

export const DiarySessionTable = () => {

    const { study } = useCurrentStudyConfigurationContext();
    const { currentUserPermissions } = useSecurityContext();
    const { data, applyFilters } = useQuery();
    const client = useWebPortalApiClient();
    const [siteOptions, setSiteOptions] = useState([]);
    const [subjectOptions, setSubjectOptions] = useState([]);

    useEffect(() => {

        const getSites = async () => {

            const sites = await client.client.getSites(undefined, `study/id eq ${study.id}`, 'number', undefined, undefined, undefined, 'groupby((study/id,id,number))');
            const options = sites.value.map(s => ({
                value: s.id,
                label: s.number,
            }));

            setSiteOptions(options);
        };

        getSites();
    }, []);

    useEffect(() => {

        const getSubjects = async () => {

            const subjects = await client.client.getSubjects(undefined, `site/study/id eq ${study.id}`, 'number', undefined, undefined, undefined, 'groupby((site/study/id,id,number))');
            const options = subjects.value.map(s => ({
                value: s.id,
                label: s.number,
            }));

            setSubjectOptions(options);
        };

        getSubjects();
    }, []);

    const handleClearFilters = () => applyFilters([]);

    const menuFormatter = (value) => {
        return (
            <div className="text-center">
                <div className="btn-group" role="group">
                    <button type="button" className="btn btn-primary btn-xs dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <FontAwesomeIcon aria-hidden="true" icon={faBars} />
                    </button>
                    <ul className="dropdown-menu scrollable-menu" role="menu">
                        <Authorization permissionIdsAny={[PermissionEnum.ViewAllDiarySessions, PermissionEnum.AccessIndividualDiaryResults]} studyId={study.id} currentPermissions={currentUserPermissions}>
                            <li>
                                <Link to={`/diary/results/${value.subject.id}`}>View</Link>
                            </li>
                        </Authorization>
                    </ul>
                </div>
            </div>
        );
    }

    return (
        <>
            <div className="row">
                <div className="col-md-6">
                    <h2 className="text-primary">Diary Sessions</h2>
                </div>
                <div className="col-md-6">
                    <div className="h2 pull-right">
                        <button className="btn btn-primary" onClick={handleClearFilters}>Clear All Filters</button>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <div className="panel panel-default">
                        <div className="panel-body">
                            <div className="table-responsive" data-automationid="DiarySessionTable">
                                <Table data={data} rowKeyField="visit.subject.id">
                                    <Column field="visit" header={<MatchSortHeader title="Site ID" field="visit/subject/site/id" options={siteOptions} sortField="visit/subject/site/number" />} formatter={visit => visit.subject.site.number} />
                                    <Column field="visit" header={<MatchSortHeader title="Subject ID" field="visit/subject/id" options={subjectOptions} sortField="visit/subject/number" />} formatter={visit => visit.subject.number} />
                                    <Column field="sessionCount" header={<SortHeader title="Sessions" field="sessionCount" />} />
                                    <Column field="lastSession" header={<SortHeader title="Last Received" field="lastSession" />} formatter={formatDateTime} />
                                    <Column field="visit" formatter={menuFormatter} />
                                </Table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
